import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import FileDownload from 'js-file-download';
import {
    Button, Card, DatePicker, Form,
} from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { useForm } from '../hooks/useForm';
import FetchService from '../services/fetch';
import { getRequiredFieldMessage } from '../helpers/form';

function ChinaManifest() {
    const [form] = useForm();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const onSaveClick = async () => {
        const { range } = await form.validateFields();
        if (Array.isArray(range)) {
            if (range[0] instanceof moment && range[1] instanceof moment) {
                setLoading(true);
                const result = await FetchService.downloadFile({
                    url: '/china/manifest',
                    method: 'POST',
                    data: { range },
                });
                if (result.success && result.data) {
                    FileDownload(result.data, `${t('manifest')}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                }
                setLoading(false);
            }
        }
    };

    return (
        <Card title={t('manifest')}>
            <Form form={form}>
                <Form.Item name="range" rules={[{ required: true, message: getRequiredFieldMessage() }]}>
                    <DatePicker.RangePicker format="DD.MM.YYYY" />
                </Form.Item>
                <Button
                    loading={loading}
                    icon={<SaveOutlined />}
                    type="primary"
                    onClick={onSaveClick}
                >
                    {t('save')}
                </Button>
            </Form>
        </Card>
    );
}

export default ChinaManifest;
